import { useEffect, useState } from 'react';
import { api } from '../api';
import { FrontVod } from '../data/FrontVod';

type UseFrontVodListData = {
    line_uid: string,
    login: string,
};

export function useFrontVodList(data: UseFrontVodListData) {
    const [frontVodList, setFrontVodList] = useState<FrontVod[]>([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (data) {
            setLoading(true);
            api.frontVod({
                ...data,
            }).then((resData) => {
                setLoading(false);
                setFrontVodList(resData);
            }).catch(() => {
                setLoading(false);
            });
        }
    }, [JSON.stringify(data)]);

    return {
        frontVodList,
        isLoading,
    };
}
